module.exports = __webpack_public_path__ + "static/media/ok.56c9f290.svg";